<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      SspActionButton(@onClick="clearL2Cache" :spinning="clearing" text="Clear All L2 Cache" buttonType="default")

    DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" :withoutPagination="true")
      tr(slot="thead")
        th Name
        th Items
        th Max Items
        th Expire-After-Write
        th Expire-After-Read
        th Hits
        th Misses
        th Estimated memory usage
        th
      tr(v-for="c in cache")
        td {{c.name}}
        td {{c.itemCount | number}}
        td {{c.maxItemCount | number}}
        td {{c.expireAfterWrite}}
        td {{c.expireAfterRead}}
        td {{c.hitCount | number}}
        td {{c.missCount | number}}
        td
          span(v-if="c.sizeInBytes") {{c.sizeInBytes | bytes}}
        td
          a(:class="isDataOrKfka(c.name) ? 'btn-danger-trash' : 'btn-trash'" @click="clearCacheItem(c.name)")
</template>

<script>
import miniToastr from 'mini-toastr'
import DataGrid from '@/components/ssp/DataGrid'
import Core from '@/service/apis/Core'
import { humanReadableBytes, numberFilter } from '@/filters/filters'

export default {
  data: () => ({
    cache: null,
    clearing: false,
  }),
  methods: {
    isDataOrKfka(name) {
      const type = name.substring(0, 4)
      if (type.includes('kfka') || type.includes('data')) {
        return true
      }
      return false
    },
    clearCacheItem(name) {
      const defaultMessage = `Are you sure you want do empty cache: ${name}?`
      const confirmMessage = this.isDataOrKfka(name) ? `<b>DANGER</b> - Clearing this data map may irreversible data loss!<br>${defaultMessage}` : defaultMessage
      const opts = {
        text: confirmMessage,
        confirmButtonType: this.isDataOrKfka(name) ? 'danger' : 'primary'
      }
      this.$confirm(opts)
        .then((conf) => {
          if (conf) {
            Core.clearCache(name)
              .then(() => {
                miniToastr.success(`${name} cache has been cleared`)
                this.$refs.grid.reload()
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          }
        })
    },
    clearL2Cache() {
      this.clearing = true
      Core.clearPersistenceCache()
        .then(() => {
          miniToastr.success('L2 cache has been cleared')
          this.$refs.grid.reload()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.clearing = false
        })
    },
    fetchData() {
      return Core.listCaches()
        .then((resp) => {
          this.cache = resp.data.content
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    hitRatioPercentage(hitRatio) {
      return `${(hitRatio * 100).toFixed(2)}%`
    }
  },
  components: {
    DataGrid
  },
  filters: {
    number: numberFilter,
    bytes: humanReadableBytes
  }
}
</script>

<style lang="scss">
  .red-trash {
    background-color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/core/system/CacheStatus.vue